import { render, staticRenderFns } from "./CheckinVitalsPanel.vue?vue&type=template&id=18fb6089"
import script from "./CheckinVitalsPanel.vue?vue&type=script&lang=js"
export * from "./CheckinVitalsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports